import { useState } from 'react';
import { Bot, Menu } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AdminSidebar } from './AdminSidebar';
import { useIsMobile } from '@sd/hooks/use-mobile';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { sd } from '@sd/lib/sdPaths';

const ADMIN_CHAT_PATH = sd('admin/chat');

interface AdminLayoutProps {
  children: React.ReactNode;
}

export function AdminLayout({ children }: AdminLayoutProps) {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const isChatPage =
    location.pathname === ADMIN_CHAT_PATH ||
    location.pathname.startsWith(`${ADMIN_CHAT_PATH}/`);

  return (
    <div className="flex h-screen w-full bg-background">
      {/* Desktop — sidebar hamesha dikhe (pehle jaisa) */}
      {!isMobile && <AdminSidebar />}

      {/* Mobile / tablet chhoti screen — drawer mein same sidebar */}
      {isMobile && (
        <Sheet open={sidebarOpen} onOpenChange={setSidebarOpen}>
          <SheetContent
            side="left"
            className="w-64 max-w-[85vw] p-0 [&>button]:hidden"
          >
            <AdminSidebar onNavigate={() => setSidebarOpen(false)} />
          </SheetContent>
        </Sheet>
      )}

      <main
        className={`relative min-w-0 flex-1 overflow-auto ${
          isChatPage ? "" : "pb-24"
        }`}
      >
        {isMobile && (
          <div className="sticky top-0 z-10 flex shrink-0 items-center gap-3 border-b bg-background px-4 py-3">
            <Button
              variant="ghost"
              size="icon"
              className="h-9 w-9"
              onClick={() => setSidebarOpen(true)}
              aria-label="Open menu"
            >
              <Menu className="h-5 w-5" />
            </Button>
            <span className="text-sm font-semibold text-foreground">Admin Panel</span>
          </div>
        )}
        {children}
        {!isChatPage ? (
          <button
            type="button"
            onClick={() => navigate(ADMIN_CHAT_PATH)}
            title="Open AI Chat"
            aria-label="Open AI Chat"
            className="fixed bottom-8 right-8 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg transition hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40"
          >
            <Bot className="h-6 w-6" />
          </button>
        ) : null}
      </main>
    </div>
  );
}
